import SimpleAccordion from '../../../Core/Expansion/SimpleAccordion';
import React, { useState,useContext } from 'react'
import FlexView from 'react-flexview'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { ReactComponent as AICircle } from '../../../../assets/ai.svg';
import { ReactComponent as PersonCircle } from '../../../../assets/person_with_circle.svg';
import { Dialog,TextField } from '@material-ui/core';
import CircledPopUpFrame from '../../../Core/CircledPopUpFrame';
import { isMobile } from 'react-device-detect';
import { EventEmitterService, EventKey } from '../../../../services/EventEmitterService';
import { SkywatchDialog } from '../../../PopUps/SkywatchDialog';
import { useLocation } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form'
import DataLayerService from '../../../../services/DataLayerService';
import {LiabilityExtensionManage,LiabilitySection} from '../PolicyDetailSections/LiabilitySection'
import PolicyLiabilityExtensionContext, { PolicyLiabilityExtensionContextStore, ACTIONS } from '../../../../context/PolicyLiabilityExtensionContext'
import {POLICY_MODIFICATION_CONTEXT_ACTIONS, ModificationContextStore} from '../../../../context/ModificationContext'
import { billingPeriodPretty, liabilityLimitPretty,AddComa } from '../../../../services/utils'
import { LiabilityCoveragePopover } from '../../../Core/Popover/LiabilityCoveragePopover'
import ViolationsService from '../../../../services/ViolationsService'
import { Action } from '../../../../models/Action';
import NewButtonPopup from "../../../Core/Buttons/NewButtonPopup";
import { NOT_COVERED_PER_PASS_LIABILITY_ID,BLACKLIST_COVERAGE_OPTIONS_AIRCRAFT_DAMAGE_LIABILITY } from '../../../../Constants'
import {
    SectionSelect,
    SectionSlider,
    SectionSpecialSelect,
    SectionTria,
} from '../../../Core/Form/FormComponents'
import { BuyingInsuranceContextStore } from '../../../../context/BuyingInsuranceContext'

interface PolicyAdditionalInsuredSectionProps {
    insurance: ActiveInsuranceModel
}


export const ModifyHoursLogged = ({ }) => {
    const modificationContext = React.useContext(ModificationContextStore) 
    const {
    subscription,
    changeHoursLogged,
    editHours
  } = useContext(ModificationContextStore);
    const offersContext = useContext(BuyingInsuranceContextStore)
    const [isOpen,setIsOpen] = React.useState(false)
    const [error, setError] = React.useState()
    const {
    control,
    handleSubmit,
    register,
    errors,
    getValues,
    formState: { dirtyFields },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      total_hours_logged: subscription.insuredPerson.totalHoursLogged,
      total_hours_multi_engine_logged: subscription.insuredPerson.totalHoursMultiEngineLogged,
      total_hours_floats_logged: subscription.insuredPerson.totalHoursFloatsLogged,
    },
  });
    

    React.useEffect(() => {
        let id = EventEmitterService.subscribe(EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS);

        return function cleanup () {
            EventEmitterService.unsubscribe(EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS, id)
        }
    }, [])



    const onSave = () =>{
        let values = getValues()
        changeHoursLogged(values)
    }

    return (
    <React.Fragment>
       <SimpleAccordion onClick={()=>setIsOpen(!isOpen)} isOpen={isOpen} className='margin-top-large'
       title={
       <FlexView column className="space-between full-width"> <div>Flight Hours</div>
       </FlexView>} 
            content={
                    <PolicyLiabilityExtensionContext>
                        <FlexView row wrap="nowrap" vAlignContent="center">
                            <Controller
    control={control} // Ensure this control is correctly passed
    name="total_hours_logged"
    rules={{
      required: 'This field is required',  
      validate: (y) => {
        if (isNaN(Number(y))) {
          return 'Please enter a valid number';
        }
        if (subscription.pilotCertification === 'Student' && y > 300) {
          return 'Students are limited to 300 logged hours.';
        }
        return true;
      },
      min: {
        value: Math.max(
          getValues('total_hours_multi_engine_logged') || 0,
          getValues('total_hours_floats_logged') || 0
        ),
        message: 'Cannot be less than partial hours'
      },
    }}
    render={(
            { onChange, onBlur, value, name, ref },
            { invalid, isTouched, isDirty }) => (
        <TextField
            disabled={!subscription.isEditHours}
             onChange={onChange}
             value={value}
            onWheel={(event) => event.target.blur()}
            variant="outlined"
            placeholder="Total hours fixed wing"
            label="Total hours fixed wing"
            type="number"
            inputRef={ref}
            style={{ marginRight: '20px',marginBottom:'20px'}}
            helperText={
              errors.total_hours_logged &&
              (errors.total_hours_logged.type == 'min'
              ? 'Cannot be less than partial hours'
              : errors.total_hours_logged.type ==
              'required'
              ? 'Required'
              : 'Students are limited to 300 logged hours. For more information, contact our support team.')
            }
            error={!!errors.total_hours_logged}
        />
    )}
/>

{subscription.multiEngineLand && <Controller
    control={control} 
    name="total_hours_multi_engine_logged"
    rules={{
      required: subscription.multiEngineLand,
      validate: (x) => x <= parseInt(getValues('total_hours_logged')) && x >= 0
    }}
    render={(
            { onChange, onBlur, value, name, ref },
            { invalid, isTouched, isDirty }) => (
        <TextField
          className="total-hours-floats-logged"
          disabled={!subscription.isEditHours}
            onChange={onChange}
             value={value}
            onWheel={(event) => event.target.blur()}
            variant="outlined"
            placeholder="Total hours multi engine"
            label="Total hours multi engine"
            type="number"
            helperText={
             errors.total_hours_multi_engine_logged &&
             (errors.total_hours_multi_engine_logged
            .type == 'validate'
              ? 'Must be less than total hours and positive'
              : 'Required')
            }
            error={
              !!errors.total_hours_multi_engine_logged
            }
        />
    )}
/>}

{subscription.singleEngineSeaplane &&
    <Controller
    control={control} // Ensure this control is correctly passed
    name="total_hours_floats_logged"
    rules={{
      required:subscription.singleEngineSeaplane,
      validate: (x) => x <= parseInt(getValues('total_hours_logged')) && x >= 0
    }}
    render={(
            { onChange, onBlur, value, name, ref },
            { invalid, isTouched, isDirty }) => (
        <TextField
            className ="total-hours-floats-logged"
            disabled={!subscription.isEditHours}
            onChange={onChange}
             value={value}
            onWheel={(event) => event.target.blur()}
            variant="outlined"
            placeholder="Total hours floats"
            label="Total hours floats"
            type="number"
            helperText={
              errors.total_hours_floats_logged &&
              (errors.total_hours_floats_logged.type == 'validate'
              ? 'Must be less than total hours and positive'
              : 'Required')
            }
            error={!!errors.total_hours_floats_logged}
        />
    )}
/>}

        <div style={{marginLeft:'10px'}}>
              {subscription.isEditHours ? (
                <NewButtonPopup onClick={(e) => {
               onSave();
               }} disabled={!dirtyFields}>
                  Save changes
                </NewButtonPopup>
              ) : (
                <NewButtonPopup onClick={(e) => {
                  e.preventDefault();
                  editHours()
                }}>Edit</NewButtonPopup>
              )}
            </div>
                        </FlexView>
                    </PolicyLiabilityExtensionContext>
                }/>
    </React.Fragment>)
}